<template>
  <div style="display: flex; flex-direction: column; height: 100%; overflow: hidden; border-left: 1px solid rgba(0,0,0,0.08)">
    <!-- Header -->
    <div style="background: linear-gradient(to right, #1565c0, #1976d2); padding: 10px 14px; flex-shrink: 0">
      <p class="body-2 font-weight-medium white--text ma-0">Resumo da Meta</p>
      <p class="caption ma-0" style="color: rgba(255,255,255,0.75)">Etapa {{ subEtapa }} de 4</p>
    </div>

    <!-- Seções -->
    <div style="flex: 1; overflow-y: auto; background: white">

      <!-- Participantes -->
      <div style="border-bottom: 1px solid rgba(0,0,0,0.08)">
        <div style="padding: 5px 12px; background: rgba(0,0,0,0.03); border-bottom: 1px solid rgba(0,0,0,0.18)">
          <p class="caption font-weight-bold text-uppercase ma-0" style="letter-spacing: 0.05em; color: rgba(0,0,0,0.7)">
            Participantes
          </p>
        </div>
        <div style="padding: 8px 12px">
          <template v-if="form.colaboradoresSelecionados.length > 0">
            <p class="caption font-weight-bold ma-0" style="color: #1976d2">
              {{ form.colaboradoresSelecionados.length }} selecionado(s)
            </p>
            <p
              v-for="funcao in funcoesComSelecionados"
              :key="funcao"
              class="caption ma-0"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: rgba(0,0,0,0.55)"
            >
              {{ funcao }}: {{ form.colaboradoresSelecionados.filter(c => c._funcao === funcao).length }}
            </p>
          </template>
          <p v-else class="caption ma-0" style="color: rgba(0,0,0,0.55)">—</p>
        </div>
      </div>

      <!-- Realizado -->
      <div style="border-bottom: 1px solid rgba(0,0,0,0.08)">
        <div style="padding: 5px 12px; background: rgba(0,0,0,0.03); border-bottom: 1px solid rgba(0,0,0,0.18)">
          <p class="caption font-weight-bold text-uppercase ma-0" style="letter-spacing: 0.05em; color: rgba(0,0,0,0.7)">
            Realizado
          </p>
        </div>
        <div style="padding: 8px 12px">
          <template v-if="form.tipoRealizado">
            <p class="caption font-weight-bold ma-0 mb-1" style="color: #1976d2">
              {{ (tiposRealizado.find(t => t.id === form.tipoRealizado) || {}).label }}
            </p>
            <p class="caption ma-0" style="font-size: 10px; line-height: 1.4; color: rgba(0,0,0,0.55)">
              <template v-if="form.tipoRealizado === 1">Será considerado o realizado individual de cada participante.</template>
              <template v-if="form.tipoRealizado === 2">
                <template v-if="form.equipesSelecionadas.length === 0">Nenhuma equipe selecionada.</template>
                <template v-else>{{ form.equipesSelecionadas.map(eq => eq.nome_equipe).join(" + ") }}</template>
              </template>
              <template v-if="form.tipoRealizado === 3">
                <template v-if="form.empresasRealizadoSelecionadas.length === 0">Nenhuma empresa selecionada.</template>
                <template v-else>{{ form.empresasRealizadoSelecionadas.map(e => e.apelido || e.nome_empresa).join(" + ") }}</template>
              </template>
            </p>
          </template>
          <p v-else class="caption ma-0" style="color: rgba(0,0,0,0.55)">—</p>
        </div>
      </div>

      <!-- Objetivo -->
      <div style="border-bottom: 1px solid rgba(0,0,0,0.08)">
        <div style="padding: 5px 12px; background: rgba(0,0,0,0.03); border-bottom: 1px solid rgba(0,0,0,0.18)">
          <p class="caption font-weight-bold text-uppercase ma-0" style="letter-spacing: 0.05em; color: rgba(0,0,0,0.7)">
            Objetivo
          </p>
        </div>
        <div style="padding: 8px 12px">
          <p v-if="form.tipoConteudo" class="caption font-weight-bold ma-0 mb-1" style="color: #1976d2">
            {{ (tiposConteudo.find(t => t.id === form.tipoConteudo) || {}).label }}
          </p>
          <template v-if="form.tipoConteudo === 1">
            <p v-if="form.indicadoresSelecionados.length === 0" class="caption ma-0" style="font-size: 10px; color: rgba(0,0,0,0.55)">Nenhum selecionado</p>
            <p
              v-for="ind in form.indicadoresSelecionados"
              :key="ind.id_indicador"
              class="caption ma-0"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: rgba(0,0,0,0.55)"
            >• {{ ind.indicador }}</p>
          </template>
          <template v-if="form.tipoConteudo === 2">
            <p v-if="form.chassisSelecionados.length === 0" class="caption ma-0" style="font-size: 10px; color: rgba(0,0,0,0.55)">Nenhum selecionado</p>
            <p
              v-for="ch in form.chassisSelecionados"
              :key="ch.chassi_completo"
              class="caption ma-0"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: rgba(0,0,0,0.55)"
            >• {{ ch.chassi_completo }}</p>
          </template>
          <template v-if="form.tipoConteudo === 3">
            <p v-if="form.modelosSelecionados.length === 0" class="caption ma-0" style="font-size: 10px; color: rgba(0,0,0,0.55)">Nenhum selecionado</p>
            <p
              v-for="m in form.modelosSelecionados"
              :key="m.id_produto"
              class="caption ma-0"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: rgba(0,0,0,0.55)"
            >• {{ nomeModelo(m) }}</p>
          </template>
          <template v-if="form.tipoConteudo === 4">
            <p v-if="form.modelosSelecionados.length === 0" class="caption ma-0" style="font-size: 10px; color: rgba(0,0,0,0.55)">Nenhum selecionado</p>
            <p
              v-for="m in form.modelosSelecionados"
              :key="m.id_peca"
              class="caption ma-0"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: rgba(0,0,0,0.55)"
            >• {{ m.id_peca }} — {{ m.peca_acessorio }}</p>
          </template>
          <template v-if="form.tipoConteudo === 5">
            <p v-if="form.modelosSelecionados.length === 0" class="caption ma-0" style="font-size: 10px; color: rgba(0,0,0,0.55)">Nenhum selecionado</p>
            <p
              v-for="m in form.modelosSelecionados"
              :key="m.id_servico"
              class="caption ma-0"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: rgba(0,0,0,0.55)"
            >• {{ m.id_servico }} — {{ m.servico }}</p>
          </template>
          <p v-if="!form.tipoConteudo" class="caption ma-0" style="color: rgba(0,0,0,0.55)">—</p>
        </div>
      </div>

      <!-- Cálculo -->
      <div>
        <div style="padding: 5px 12px; background: rgba(0,0,0,0.03); border-bottom: 1px solid rgba(0,0,0,0.18)">
          <p class="caption font-weight-bold text-uppercase ma-0" style="letter-spacing: 0.05em; color: rgba(0,0,0,0.7)">
            Cálculo
          </p>
        </div>
        <div style="padding: 8px 12px">
          <p v-if="resumoCalculoTexto" class="caption ma-0" style="color: #1976d2; line-height: 1.5">
            {{ resumoCalculoTexto }}
          </p>
          <p v-else class="caption ma-0" style="color: rgba(0,0,0,0.55)">—</p>
          <template v-if="custoEstimado.total > 0">
            <p class="caption ma-0 mt-2" style="font-size: 10px; color: rgba(0,0,0,0.55)">
              {{ custoEstimado.nSemanas > 1 ? `Total máximo (${custoEstimado.nSemanas} semanas)` : "Total estimado" }}
            </p>
            <p class="caption font-weight-bold ma-0" style="color: #1976d2">
              {{ formatarMoeda(custoEstimado.total) }}
            </p>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import currencyMixin from "@/mixins/currencyMixin";
import { formatarNomeModelo } from "./nomeModeloUtils";

export default {
  name: "ModalCadastroSubEtapaResumoMeta",

  mixins: [currencyMixin],

  props: {
    form: { type: Object, required: true },
    subEtapa: { type: Number, default: 1 },
    custoEstimado: {
      type: Object,
      default: () => ({ total: 0, nSemanas: 1 })
    },
    empresas: { type: Array, default: () => [] }
  },

  data() {
    return {
      tiposConteudo: [
        { id: 1, label: "Indicador", icon: "mdi-chart-bar" },
        { id: 2, label: "Chassi", icon: "mdi-car-cog" },
        { id: 3, label: "Modelo", icon: "mdi-car" },
        { id: 4, label: "Peças e Acessórios", icon: "mdi-package-variant" },
        { id: 5, label: "Serviços", icon: "mdi-wrench" }
      ]
    };
  },

  computed: {
    tiposRealizado() {
      const base = [
        { id: 1, label: "Individual" },
        { id: 2, label: "Equipe" },
        { id: 3, label: "Empresa" }
      ];
      if (this.empresas.length > 1) {
        base.push({ id: 4, label: "Empresa(s)" });
      }
      return base;
    },

    funcoesComSelecionados() {
      const funcoes = [...new Set(this.form.colaboradoresSelecionados.map(c => c._funcao))];
      return funcoes.sort((a, b) => a.localeCompare(b, "pt-BR"));
    },

    resumoCalculoTexto() {
      const form = this.form;
      const bonus = form.valorBonus ? this.formatarMoeda(parseFloat(form.valorBonus)) : null;

      if (form.tipoConteudo === 2) {
        return "Bônus por chassi vendido, valor configurado por item";
      }

      if (form.tipoConteudo === 3) {
        if (form.tipoCalculo === 2) {
          return form.tipoPagamento === 1
            ? "Bônus por unidade vendida de cada modelo em faixas progressivas de desempenho"
            : "Bônus fixo por faixa de desempenho atingida para cada modelo";
        }
        return form.tipoPagamento === 1
          ? "Bônus por unidade vendida de cada modelo ao atingir a meta"
          : "Bônus fixo ao atingir a meta de vendas de cada modelo";
      }

      if (form.tipoConteudo === 4) {
        if (form.tipoCalculo === 2) {
          return form.tipoPagamento === 1
            ? "Bônus por unidade vendida de cada peça em faixas progressivas de desempenho"
            : "Bônus fixo por faixa de desempenho atingida para cada peça";
        }
        return form.tipoPagamento === 1
          ? "Bônus por unidade vendida de cada peça ao atingir a meta"
          : "Bônus fixo ao atingir a meta de vendas de cada peça";
      }

      if (form.tipoConteudo === 5) {
        if (form.tipoCalculo === 2) {
          return form.tipoPagamento === 1
            ? "Bônus por unidade realizada de cada serviço em faixas progressivas de desempenho"
            : "Bônus fixo por faixa de desempenho atingida para cada serviço";
        }
        return form.tipoPagamento === 1
          ? "Bônus por unidade realizada de cada serviço ao atingir a meta"
          : "Bônus fixo ao atingir a meta de serviços realizados";
      }

      if (!form.tipoCalculo) return null;

      const inds = form.indicadoresSelecionados || [];
      const nomes = inds.map(ind => ind.indicador);
      const nomeTexto =
        nomes.length === 0
          ? ""
          : nomes.length === 1
          ? `de ${nomes[0]}`
          : `de ${nomes.slice(0, -1).join(", ")} e ${nomes.slice(-1)[0]}`;

      if (form.tipoCalculo === 2) {
        return form.tipoPagamento === 1
          ? `Bônus por unidade ${nomeTexto} em faixas progressivas de desempenho`.trim()
          : `Bônus fixo ${nomeTexto} por faixa de desempenho atingida`.trim();
      }

      const pares = inds.map(ind => {
        const v = form.metasIndicadores[ind.id_indicador]?.metaValor;
        return v ? `${ind.indicador} (meta: ${parseFloat(v)})` : ind.indicador;
      });

      let sufixoMeta;
      if (pares.length === 0) {
        sufixoMeta = "a meta";
      } else if (pares.length === 1) {
        sufixoMeta = `a meta de ${pares[0]}`;
      } else {
        sufixoMeta = `as metas de ${pares.slice(0, -1).join(", ")} e ${pares.slice(-1)[0]}`;
      }

      if (!bonus) {
        return form.tipoPagamento === 1
          ? `Bônus por unidade, desde que atinja ${sufixoMeta}`
          : `Bônus fixo ao atingir ${sufixoMeta}`;
      }
      return form.tipoPagamento === 1
        ? `Bônus de ${bonus} por unidade, desde que atinja ${sufixoMeta}`
        : `Bônus fixo de ${bonus} ao atingir ${sufixoMeta}`;
    }
  },

  methods: {
    // Task 21: este resumo nunca mostrou cod_modelo (so descricao_modelo,
    // diferente do bullet de peca/servico logo abaixo, que usa id — descricao).
    // Mantido assim de proposito — nao mexe no fluxo de criacao, que ja
    // funciona. So garante, com o mesmo helper dos demais lugares, que uma
    // descricao ausente cai num travessao em vez de bullet vazio.
    nomeModelo(m) {
      return formatarNomeModelo(null, m.descricao_modelo);
    }
  }
};
</script>
